<template>
  <div class="content-container">
    <!-- Lewy panel: filtry do bieżących pomiarów -->
    <filters-current-measurement />

    <div class="content-wrap">
      <!-- Górne menu nawigacyjne -->
      <TopMenu />
      <!-- Komponent główny: obsługa kroków i widoków bieżącego pomiaru -->
      <CurrentMeasurement />
    </div>
  </div>
</template>

<script>
// Importy Pinia, komponentów i stores
import { useCurrentStore } from "@/stores/current";
import TopMenu from "../components/TopMenu.vue";
import CurrentMeasurement from "../components/CurrentMeasurement.vue";
import FiltersCurrentMeasurement from "@/components/FiltersCurrentMeasurement.vue";
import { useVmsStore } from "@/stores/vms";
import { useUserStore } from "@/stores/user.store";

export default {
  name: "HomeView",
  components: {
    TopMenu,
    CurrentMeasurement,
    FiltersCurrentMeasurement,
  },
  setup() {
    // Store do obsługi stanu bieżącego kroku (krok, widok, itp.)
    const current = useCurrentStore();
    const userStore = useUserStore();

    // Jeśli użytkownik ma dostęp do VMS, ładujemy dane VMS
    if (userStore.hasAccess('Vms')) {
      const vmsStore = useVmsStore();
      if (!vmsStore.isLoaded) {
        vmsStore.loadData();
      }
    }
    
    return {
      current,
    };
  },
  data() {
    return {
      // step: this.current.step, // aktualny krok
      isResult: this.current.isResult // czy jesteśmy na kroku z wynikami
    };
  },
  created() {
    // Obserwuj zmianę kroku w store, synchronizuj ze swoim stanem lokalnym
    // this.$watch(
    //   () => this.current.step,
    //   () => {
    //     this.getCurrentStep();
    //   }
    // );
  },
  methods: {
    // Aktualizuj lokalny krok (np. po zmianie w store)
    // getCurrentStep() {
    //   this.step = this.current.step;
    // },
    // // Przejdź do kolejnego kroku (wywołuje logikę store)
    // nextStep() {
    //   this.step = this.current.nextStep();
    // },
    // // Wróć do poprzedniego kroku (wywołuje logikę store)
    // previousStep() {
    //   this.step = this.current.previousStep();
    // },
  },
};
</script>

<style scoped>
/* Kontener główny z tłem */
.content-container {
  background-color: #f5f4f2;
}

/* Ogólne stylowanie przycisków nawigacji */
button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}

/* Styl przycisku "Dalej" */
.btn-next {
  margin-right: 50px;
  padding: 8px 40px 8px 8px;
  position: relative;
  color: #58585a;
}
/* Ikona strzałki (dalej) */
.btn-next:before {
  content: "";
  position: absolute;
  right: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/dalej.png") no-repeat left top;
}
/* Hover na przycisk "Dalej" */
.btn-next:hover {
  color: black;
}
.btn-next:hover:before {
  background: url("../assets/icons/dalej_over.png") no-repeat left top;
}

/* Styl przycisku "Wstecz" */
.btn-prev {
  margin-left: 30px;
  padding: 8px 8px 8px 45px;
  position: relative;
  color: #58585a;
}
/* Ikona strzałki (wstecz) */
.btn-prev:before {
  content: "";
  position: absolute;
  left: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}
.btn-prev:hover {
  color: black;
}
.btn-prev:hover:before {
  background: url("../assets/icons/powrot_over.png") no-repeat left top;
}

/* Dół panelu: kontener na przyciski */
.actions-down {
  background-color: white;
  min-height: 43px;
}

/* Specjalne style tylko dla dolnych przycisków */
.actions-down button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}

/* Stylowanie .btn-next i .btn-prev wewnątrz .actions-down */
.actions-down .btn-next {
  margin-right: 50px;
  padding: 8px 40px 8px 8px;
  position: relative;
  color: #58585a;
}
.actions-down .btn-next:before {
  content: "";
  position: absolute;
  right: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/dalej.png") no-repeat left top;
}
.actions-down .btn-next:hover {
  color: black;
}
.actions-down .btn-next:hover:before {
  background: url("../assets/icons/dalej_over.png") no-repeat left top;
}

.actions-down .btn-prev {
  margin-left: 30px;
  padding: 0 0 0 40px;
  position: relative;
  color: #58585a;
}
.actions-down .btn-prev:before {
  content: "";
  position: absolute;
  left: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}
.actions-down .btn-prev:hover {
  color: black;
}
.actions-down .btn-prev:hover:before {
  background: url("../assets/icons/powrot_over.png") no-repeat left top;
}
</style>
